export default __webpack_public_path__ + "static/media/kravlji_sir_vakum.a9ff77a1.jpg";